import React, { forwardRef, useState, useEffect, useMemo, useId, useContext, createElement } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './index.external.css';

function _defineProperty$1(e, r, t) {
  return (r = _toPropertyKey$1(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) {
      _defineProperty$1(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties$1(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}
function _toPrimitive$1(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey$1(t) {
  var i = _toPrimitive$1(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

var styles = {"link":"link-SXSzo","linkContent":"linkContent-SXSzo","arrowIcon":"arrowIcon-SXSzo","arrowIconLeft":"arrowIconLeft-SXSzo","linkMediumFontWeight":"linkMediumFontWeight-SXSzo","linkArrowUnderline":"linkArrowUnderline-SXSzo","linkUnderline":"linkUnderline-SXSzo","linkUnderlineAnimated":"linkUnderlineAnimated-SXSzo","linkArrowBold":"linkArrowBold-SXSzo","linkIcon":"linkIcon-SXSzo","arrowIconRight":"arrowIconRight-SXSzo","left":"left-SXSzo"};

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }
  return getRandomValues(rnds8);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }
  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;
    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
var _excluded$1 = ["className", "content", "title", "role", "aria-labelledby", "aria-hidden"];

// Custom hook to grab a default iconId using React.useId()
// NOTE: useId is only available in React 18+
var useDefaultIconId = () => {
  var reactId = useId === null || useId === void 0 ? void 0 : useId();
  if (reactId) return "icon_".concat(reactId);
  return undefined;
};
var Icon = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      className,
      content,
      title,
      role,
      'aria-labelledby': ariaLabelledby,
      'aria-hidden': ariaHidden
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded$1);
  var [iconId, setIconId] = useState(useDefaultIconId());
  useEffect(() => {
    // If using React < 18, use UUID to render the unique iconId
    // UUID v4 causes hydration issues in SSR because it consumes crypto.
    //    Crypto is a built in node.js package and is not consumed properly in Next.js
    //    So UUID value needs to be set from useEffect which renders client side.
    if (!iconId) {
      setIconId("icon_".concat(v4()));
    }
  }, [iconId]);
  var {
    'aria-label': ariaLabel,
    'aria-describedby': ariaDescribedby
  } = otherProps;
  var hasLabel = !!title || !!ariaLabelledby || !!ariaLabel || !!ariaDescribedby;
  return useMemo(() => {
    var _content$props;
    if (!content) return null;
    return /*#__PURE__*/React.cloneElement(content, _objectSpread2({
      children: /*#__PURE__*/React.createElement(React.Fragment, null, title ? /*#__PURE__*/React.createElement("title", {
        id: iconId
      }, title) : null, content === null || content === void 0 ? void 0 : (_content$props = content.props) === null || _content$props === void 0 ? void 0 : _content$props.children),
      className,
      ref,
      focusable: false,
      role,
      'data-lll-pl': 'icon',
      'aria-labelledby': ariaLabelledby || (title ? iconId : undefined),
      'aria-hidden': typeof ariaHidden !== 'undefined' ? ariaHidden : !hasLabel
    }, otherProps));
  }, [content, className, title, role, hasLabel, ref, ariaLabelledby, ariaHidden, otherProps, iconId]);
});
var propTypes$1 = {
  /** Node for the individual icon import */
  content: PropTypes.node.isRequired,
  /** Optional class to be applied to the SVG element */
  className: PropTypes.string,
  /** Value for the <title> element describing the icon */
  title: PropTypes.string,
  role: PropTypes.string,
  /** By default points to the <title> element, if provided. */
  'aria-labelledby': PropTypes.string,
  /** By default is set to 'true' if no title or label is provided. */
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
var defaultProps$1 = {
  className: null,
  title: '',
  role: 'img',
  'aria-labelledby': undefined,
  'aria-hidden': undefined
};
Icon.propTypes = propTypes$1;
Icon.defaultProps = defaultProps$1;

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var rightLinkArrowIcon = /*#__PURE__*/React.createElement("svg", {
  height: "16",
  width: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.53 2.47 5 5a.75.75 0 0 1 .01 1.04l-5 5-.35-.35a1 1 0 0 1 0-1.42l3-3H5a1 1 0 0 1-1-1v-.5h9.18l-3-3a1 1 0 0 1 0-1.42l.35-.35ZM2 7.25a1 1 0 0 1 1 1v.5H1a1 1 0 0 1-1-1v-.5Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

var DEFAULT_LINK_TYPE = 'a';
var LinkProviderContext = /*#__PURE__*/React.createContext(DEFAULT_LINK_TYPE);
({
  /** The component/element pattern library components (and LinkGenerator) should use for links */
  component: PropTypes.elementType.isRequired,
  children: PropTypes.node
});

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var LinkGenerator = /*#__PURE__*/React.forwardRef((props, ref) => {
  var Link = useContext(LinkProviderContext) || DEFAULT_LINK_TYPE;
  return /*#__PURE__*/React.createElement(Link, _extends({
    ref: ref
  }, props));
});

var _excluded = ["children", "className", "direction", "fontWeight", "href", "icon", "tag", "textStyle", "variant", "onClick"];
var Link = _ref => {
  var {
      children,
      className,
      direction,
      fontWeight,
      href,
      icon,
      tag,
      textStyle,
      variant,
      onClick
    } = _ref,
    rest = _objectWithoutProperties$1(_ref, _excluded);
  var hasIcon = !!icon;
  var isArrowVariant = variant === 'arrowBold' || variant === 'arrowUnderline';
  var getIcon = () => {
    if (!hasIcon) {
      if (!isArrowVariant) {
        return null;
      } else {
        return /*#__PURE__*/React.createElement(Icon, {
          className: cn(styles.linkIcon, styles.arrowIcon, {
            [styles.left]: direction === 'left'
          }),
          content: rightLinkArrowIcon,
          "aria-hidden": "true",
          "data-testid": "link-icon__arrow"
        });
      }
    } else {
      return /*#__PURE__*/React.createElement(Icon, {
        content: icon,
        "aria-hidden": "true",
        "data-testid": "link-icon",
        className: cn(styles.linkIcon)
      });
    }
  };
  var iconComponent = getIcon();
  var linkContent = /*#__PURE__*/React.createElement("span", {
    className: styles.linkContent
  }, children);
  var classes = cn(styles.link, className, {
    [styles.linkUnderline]: variant === 'underline',
    [styles.linkUnderlineAnimated]: variant === 'underlineAnimated',
    [styles.linkArrowBold]: variant === 'arrowBold',
    [styles.linkArrowUnderline]: variant === 'arrowUnderline',
    [styles.arrowIconRight]: direction === 'right',
    [styles.arrowIconLeft]: direction === 'left',
    [styles.linkMediumFontWeight]: fontWeight === 'medium'
  });
  return /*#__PURE__*/createElement(tag, _objectSpread2$1({
    href,
    className: "lll-text-".concat(textStyle, " ").concat(classes),
    onClick,
    'data-lll-pl': 'link'
  }, rest), /*#__PURE__*/React.createElement(React.Fragment, null, direction !== 'right' && iconComponent, linkContent, direction === 'right' && iconComponent));
};
var propTypes = {
  children: PropTypes.node.isRequired,
  /* choose a classname */
  className: PropTypes.string,
  /** indicates the direction of the link */
  direction: PropTypes.oneOf(['left', 'right', undefined]),
  textStyle: PropTypes.oneOf(['body-1', 'body-2', 'body-3']),
  fontWeight: PropTypes.oneOf(['regular', 'medium']),
  href: PropTypes.string,
  icon: PropTypes.node,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  variant: PropTypes.oneOf(['underline', 'arrowBold', 'arrowUnderline', 'underlineAnimated']),
  onClick: PropTypes.func
};
var defaultProps = {
  className: '',
  direction: undefined,
  textStyle: 'body-2',
  fontWeight: 'regular',
  href: undefined,
  icon: null,
  tag: LinkGenerator,
  variant: 'underline',
  onClick: () => {}
};
Link.propTypes = propTypes;
Link.defaultProps = defaultProps;

export { Link, defaultProps, propTypes };
//# sourceMappingURL=index.js.map
